import { composeIO } from 'react-compose-io'
import { informacaoParceiroIO } from './InformacaoParceiro.IO'
import { InformacaoParceiroView } from './InformacaoParceiro.View'

export const InformacaoParceiro = composeIO(InformacaoParceiroView, informacaoParceiroIO)
